// extracted by mini-css-extract-plugin
export default {"price":"G9-z","onSale":"H9-z","msrpLabelPrice":"I9-z","msrpLabel":"J9-z","originalPrice":"K9-z","percentOff":"L9-z"};